import { InsulinRepository } from '@/io/repository/InsulinRepository.ts';
import { makeQueryKey } from '@/queries/Queries';
import { createQuery } from '@/queries/utils/CreateQuery';
import { DiabetesDataParams } from '@/queries/utils/DiabetesQueryUtils.ts';

export class InsulinQueries {
  constructor(
    private readonly diabetes: InsulinRepository = new InsulinRepository(),
  ) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  useInsulinPump = createQuery(
    'insulin-devices',
    data =>
      makeQueryKey(
        data.patientId,
        data.from?.toISODate(),
        data.to?.toISODate(),
      ),
    async (data: DiabetesDataParams) =>
      await this.diabetes.getActiveInsulinDevice(
        data.patientId,
        data.from,
        data.to,
      ),
  );
}
